<div class="radios-container" [formGroup]="form">
  <p>42.Tipo de reporte *</p>
  <mat-radio-group aria-label="Select an option" formControlName="reportType">
    <div class="options">
      <mat-radio-button class="primary-radiobutton" value="puntual"
        >Operación puntual
      </mat-radio-button>
      <mat-radio-button class="primary-radiobutton" value="multiple"
        >Múltiples operaciones
      </mat-radio-button>
      <mat-radio-button class="primary-radiobutton" value="other"
        >Otro tipo de reporte
      </mat-radio-button>
    </div>
  </mat-radio-group>
</div>
